// extracted by mini-css-extract-plugin
export default {"add":"FilterConditionsGroup_add__7XbeG"};